export const ADMIN_PATH = '/admin';
export const ADMIN_ORGANIZATION_PATH = '/admin/organization';
